import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-exception-image',
  templateUrl: './exception-image.component.html',
  styleUrls: ['./exception-image.component.scss']
})
export class ExceptionImageComponent {

  @Input() image;
  @Output() clear = new EventEmitter();
  @Output() select = new EventEmitter();

  onClear() {
    this.clear.emit(this.image.uuid);
  }

  onSelect() {
    this.select.emit(this.image.uuid);
  }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/utilities/components/exception-image/exception-image.component.ts